import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

// Genuine 404 page for unknown URLs (replaces the previous soft-404 that
// redirected every unknown URL to the homepage). Marked noindex.
const NotFound = () => {
  return (
    <>
      <SEO
        title="Page Not Found (404) | WristCoin"
        description="The page you are looking for could not be found."
        path="/404"
        noindex
      />
      <div className="bg-[#101F27] text-white min-h-screen flex items-center justify-center px-4">
        <div className="max-w-xl text-center py-24">
          <div className="text-[#009688] text-7xl font-bold mb-4">404</div>
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Page not found
          </h1>
          <p className="text-gray-400 mb-8">
            Sorry, the page you were looking for doesn&apos;t exist or may have
            moved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="px-6 py-3 rounded-lg bg-gradient-to-r from-[#009688] to-[#005B4F] text-white font-semibold"
            >
              Back to Home
            </Link>
            <Link
              to="/case-studies"
              className="px-6 py-3 rounded-lg border border-[#009688] text-[#009688] font-semibold"
            >
              View Case Studies
            </Link>
            <Link
              to="/blog"
              className="px-6 py-3 rounded-lg border border-gray-700 text-gray-300 font-semibold"
            >
              Read the Blog
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
